export default __webpack_public_path__ + "static/media/browse-hunting-site.f3ccda65.png";